type E = 'development' | 'production';
const ENV_OVERRIDE: E | null = 'production';
export const ENVIRONMENT: E = ENV_OVERRIDE ?? (process.env.NODE_ENV === 'development' ? 'development' : 'production');

export const API_BASE_URL = new URL('/api/v1', location.href).href;

export const AUTH0_DOMAIN = 'zorgverkeer.eu.auth0.com';
export const AUTH0_ID = '8NQnVS1vMX6BzV7oH28tQJqcruvv6kcf';
export const AUTH0_AUDIENCE = 'https://zorgverkeer.eu.auth0.com/api/v2/';
export const AUTH0_SCOPE = 'read:current_user';
// Local testing only: when set (and running under `npm start`), Auth0 is skipped and the app acts as this user.
// The back-end must run with the matching AUTH_BYPASS_EMAIL, since no real token is sent.
export const AUTH_BYPASS_EMAIL: string | null =
	process.env.NODE_ENV === 'development' ? process.env.REACT_APP_AUTH_BYPASS_EMAIL || null : null;
export const AUTH0_RETURN_TO =
	window.location.host === 'aanbieder-pretest.teamzorgportaal.nl'
		? 'https://aanbieder-pretest.teamzorgportaal.nl/'
		: window.location.host === 'aanbieder-test.teamzorgportaal.nl'
			? 'https://aanbieder-test.teamzorgportaal.nl/'
			: window.location.host === 'aanbieder-acc.teamzorgportaal.nl'
				? 'https://aanbieder-acc.teamzorgportaal.nl/'
				: window.location.host === 'aanbieder.teamzorgportaal.nl'
					? 'https://aanbieder.teamzorgportaal.nl/'
					: 'http://localhost:3000/';

export const CLIENT_LIST_INDEX = 20;

export const DISPLAY_RELOAD = true;
export const DISPLAY_RELOGIN = true;

const SECOND = 1000;
const MINUTE = 1000 * 60;
export const FETCH_RETRIES = 12;
export const FETCH_MIN_DELAY = 10 * SECOND;
export const FETCH_TIMEOUT = 30 * SECOND;
export const FETCH_NOTIFY = 1 * SECOND;

export const NOTIFICATION_TIMER = 5 * MINUTE;
export const TOKEN_TIMER = 15 * MINUTE;

export const FILTER_STATEMENTS_FOR_INVOICES = true;
export const FILTER_DATE_MAX = '4712-12-31';

export const MAX_NOTIFICATION_ITEMS = 9;
